import moment from 'moment';
import { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { toast } from 'react-toastify';

import { DATE_TIME_FORMAT } from '../../../constants';
import { BasicModal, Button } from '../../Shared';

import './react-date-picker.css';

export const RescheduleDemoModal = ({
  open,
  reportToReschedule,
  onClose,
  fetchReports,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onChangeSelectedDate = nextSelectedDate => {
    setSelectedDate(nextSelectedDate);
  };

  const onSubmit = async () => {
    setIsSubmitting(true);

    try {
      const response = await fetch('/reschedule-booking', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          CallerID: reportToReschedule.CallerID,
          LeadID: reportToReschedule.LeadID,
          ApptID: reportToReschedule.ApptID,
          rescheduledDate: moment(selectedDate).format(
            DATE_TIME_FORMAT.YYYY_MM_DD_DASH,
          ),
          rescheduledTime: moment(selectedDate).format(DATE_TIME_FORMAT.h_mm_A),
        }),
      });

      if (response.status !== 200) throw new Error();

      setIsSubmitting(false);
      onClose();
      fetchReports();
    } catch {
      setIsSubmitting(false);
      toast.error('Something went wrong, please try again!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const isButtonRescheduleDisabled = !selectedDate || isSubmitting;

  return (
    <BasicModal
      open={open}
      handleClose={isSubmitting ? undefined : onClose}
      className="flex items-center justify-center w-full h-full"
    >
      <div className="bg-white w-[376px] rounded-2xl shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)]">
        <div className="flex items-center justify-between py-4 pl-5 pr-4 border-b border-b-base-200">
          <span className="text-base-1000 font-semibold text-[22px]/[28px]">
            Reschedule Demo
          </span>
          <button
            type="button"
            className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-transparent text-sm font-semibold text-gray-800 transition hover:bg-gray-100 disabled:pointer-events-none disabled:opacity-50 dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            data-hs-overlay="#edit-contact-modal"
            onClick={onClose}
            disabled={isSubmitting}
          >
            <span className="sr-only">Close</span>
            <svg
              className="h-4 w-4 flex-shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        <div className="flex flex-col gap-4 pt-2 px-5 pb-4">
          <ReactDatePicker
            selected={selectedDate}
            onChange={onChangeSelectedDate}
            inline
            calendarClassName="reschedule-demo-datepicker"
            showTimeInput
            timeInputLabel=""
          />
          {/* TODO: use time zone from BE */}
          {/* <div className="flex items-center gap-4 h-7">
            <span className="font-medium text-[16px]/[24px] text-base-800">
              Lead Time Zone:
            </span>
            <span className="text-[18px]/[24px] text-base-1000">
              Baltimore/Maryland
            </span>
          </div> */}
        </div>
        <div className="flex justify-end py-4 px-5 border-t border-t-base-200 gap-3">
          <Button
            title="Cancel"
            variant="blue"
            onClick={onClose}
            disabled={isSubmitting}
          />
          <Button
            title="Reschedule"
            onClick={onSubmit}
            disabled={isButtonRescheduleDisabled}
          />
        </div>
      </div>
    </BasicModal>
  );
};
